import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { services } from '../data/services';
export const Services: React.FC = () => {
  return <div className="w-full bg-white py-20 md:py-24" data-id="element-696" data-mp="1dtj1tghdno1h">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-697" data-mp="1dw5c3nvnkhne">
        <div className="max-w-3xl mb-14" data-id="element-698" data-mp="18ufxxzd4vnv3">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-699" data-mp="13vuxbytyz264">
            Zes diensten, één doel: zichtbaar en geloofwaardig zijn
          </motion.h2>
          <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-700" data-mp="l5n0fygv57yd">
            Je hoeft niet alles af te nemen. De meeste ondernemers beginnen bij
            een website of bij hun vormgeving, en breiden pas uit als daar
            resultaat uit komt.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-701" data-mp="3b2xytvzyjbnm">
          {services.map((service, index) => {
          const Icon = service.icon;
          const isFeatured = index < 2;
          return <motion.a key={service.title} href={service.link} target={service.external ? '_blank' : undefined} rel={service.external ? 'noopener noreferrer' : undefined} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: Math.min(index, 4) * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`group flex flex-col rounded-2xl border transition-colors duration-200 ${isFeatured ? 'lg:col-span-2 bg-[#F7F8FA] border-gray-200 p-8 hover:border-[#004AC7]' : 'bg-white border-gray-200 p-6 hover:border-[#004AC7]'}`} data-id="element-702" data-mp="32acsjfdiixfo" data-mpi={index}>
                <div className={`flex items-center justify-center rounded-xl bg-white text-[#004AC7] border border-gray-100 mb-5 ${isFeatured ? 'w-14 h-14' : 'w-11 h-11'}`} data-id="element-703" data-mp="1pisug6tksngw">
                  <Icon className={isFeatured ? 'h-7 w-7' : 'h-5 w-5'} aria-hidden="true" data-id="element-704" data-mp="1gr8zlvs26xr7" />
                </div>
                <h3 className={`font-bold text-[#111827] mb-2 ${isFeatured ? 'text-2xl' : 'text-lg'}`} data-id="element-705" data-mp="1brmopszpdtlk">
                  {service.title}
                </h3>
                <p className={`text-[#6B7280] leading-relaxed flex-grow ${isFeatured ? 'text-base mb-6' : 'text-sm mb-5'}`} data-id="element-706" data-mp="11uhztleh3k12">
                  {service.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-[#004AC7] font-semibold text-sm mt-auto" data-id="element-707" data-mp="xv0vivas8sxh">
                  {service.external ? 'Naar coreprint.nl' : `Bekijk ${service.title.toLowerCase()}`}
                  {service.external ? <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-708" data-mp="2n7bcunop0yny" /> : <ArrowRightIcon className="h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-709" data-mp="2n5rtgo7qq7hy" />}
                </span>
              </motion.a>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-16 border-t border-gray-200 pt-10 flex flex-col md:flex-row md:items-center gap-8" data-id="element-710" data-mp="34h6v7saeupmq">
          <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden, de mascotte van Noord Digital" loading="lazy" className="w-24 h-24 object-contain flex-shrink-0" data-id="element-711" data-mp="2grunkwuqepmj" />
          <div className="flex-grow" data-id="element-712" data-mp="2ppy1b6zh6i3s">
            <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-713" data-mp="1188bor8ohuf">
              Weet je niet waar je moet beginnen?
            </h3>
            <p className="text-[#6B7280] leading-relaxed" data-id="element-714" data-mp="508lorqy6sa1">
              In een gesprek van een half uur kijken we naar je huidige
              vindbaarheid en vertellen we wat we zouden aanpakken. Je zit
              daarna tot niets verplicht.
            </p>
          </div>
          <a href="#contact" className="inline-flex items-center justify-center bg-[#004AC7] hover:bg-[#003A9E] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex-shrink-0" data-id="element-715" data-mp="dju1tuz8f9id">
            Plan een kennismaking
          </a>
        </motion.div>
      </div>
    </div>;
};